export enum TransactionsTabEnum {
  History = 'history',
  Statements = 'statements',
}
